module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp23_7.fd60b9f2.png";